document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const normalizeText = (value) => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

const menuToggle = document.querySelector('[data-menu-toggle]');
const mainNav = document.querySelector('[data-main-nav]');
if (menuToggle && mainNav) {
  menuToggle.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!open));
    menuToggle.setAttribute('aria-label', open ? 'Abrir menú' : 'Cerrar menú');
    mainNav.classList.toggle('is-open', !open);
  });
}

document.querySelectorAll('[data-carousel]').forEach((carousel) => {
  const slides = [...carousel.querySelectorAll('[data-slide]')];
  const dots = [...carousel.querySelectorAll('[data-slide-to]')];
  let current = 0;
  let timer;
  const show = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === current;
      slide.classList.toggle('is-active', active);
      slide.hidden = !active;
      slide.setAttribute('aria-hidden', String(!active));
    });
    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === current;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', String(active));
    });
  };
  const stop = () => window.clearInterval(timer);
  const start = () => {
    stop();
    if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(current + 1), 6500);
  };
  carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => { show(current - 1); start(); });
  carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => { show(current + 1); start(); });
  dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.slideTo)); start(); }));
  carousel.addEventListener('mouseenter', stop);
  carousel.addEventListener('mouseleave', start);
  show(0);
  start();
});

const collectionSearch = document.querySelector('[data-collection-search]');
if (collectionSearch) {
  const root = collectionSearch.closest('.collection-page');
  const grid = root?.querySelector('[data-collection-grid]');

  if (grid) {
    const count = root.querySelector('[data-visible-count]');
    const empty = root.querySelector('[data-collection-empty]');
    const pagination = root.querySelector('.pagination');
    const originalNodes = [...grid.childNodes];
    const originalCards = [...grid.querySelectorAll('[data-product-card]')];
    const originalCount = count?.textContent || '';
    const originalPaginationHidden = pagination?.hidden || false;
    const currentUrl = new URL(window.location.href);
    const currentPage = Number(currentUrl.searchParams.get('page')) || 1;
    const wrapper = root.closest('[id^="shopify-section-"]');
    const sectionId = wrapper?.id.replace(/^shopify-section-/, '');

    const status = document.createElement('p');
    status.className = 'collection-search-status';
    status.setAttribute('role', 'status');
    status.hidden = true;
    grid.before(status);

    let allCards;
    let loading;
    let debounce;

    const getNextPage = (pageRoot, page) => {
      return [...pageRoot.querySelectorAll('.pagination a[href]')]
        .map((link) => new URL(link.getAttribute('href'), currentUrl))
        .find((url) => url.origin === currentUrl.origin &&
          url.pathname === currentUrl.pathname &&
          Number(url.searchParams.get('page')) > page);
    };

    const loadAllCards = () => {
      if (allCards) return Promise.resolve(allCards);
      if (loading) return loading;

      loading = (async () => {
        const cards = [];
        const visited = new Set();
        let pageUrl = new URL(currentUrl);
        pageUrl.searchParams.set('page', '1');

        while (pageUrl) {
          const page = Number(pageUrl.searchParams.get('page')) || 1;

          if (visited.has(page)) {
            throw new Error('Paginación repetida');
          }

          visited.add(page);
          let pageRoot;

          if (page === currentPage) {
            pageRoot = root;
            cards.push(...originalCards);
          } else {
            const requestUrl = new URL(pageUrl);

            if (sectionId) {
              requestUrl.searchParams.set('section_id', sectionId);
            }

            const response = await fetch(requestUrl.toString(), {
              credentials: 'same-origin'
            });

            if (!response.ok) {
              throw new Error('No se pudo cargar la colección');
            }

            const pageDocument = new DOMParser().parseFromString(
              await response.text(),
              'text/html'
            );

            pageRoot = pageDocument.querySelector('.collection-page');
            const pageGrid = pageRoot?.querySelector('[data-collection-grid]');

            if (!pageGrid) {
              throw new Error('Respuesta de colección incompleta');
            }

            cards.push(...pageGrid.querySelectorAll('[data-product-card]'));
          }

          pageUrl = getNextPage(pageRoot, page);
        }

        const expected = Number(originalCount.trim());

        if (count && Number.isFinite(expected) && cards.length !== expected) {
          throw new Error('No se cargaron todos los productos');
        }

        allCards = cards;
        return cards;
      })().finally(() => {
        loading = null;
      });

      return loading;
    };

    const restorePage = () => {
      originalCards.forEach((card) => {
        card.hidden = false;
      });

      grid.replaceChildren(...originalNodes);
      grid.hidden = false;
      grid.removeAttribute('aria-busy');

      if (count) count.textContent = originalCount;
      if (empty) empty.hidden = true;
      if (pagination) pagination.hidden = originalPaginationHidden;

      status.hidden = true;
      status.textContent = '';
    };

    const searchCollection = async () => {
      if (!normalizeText(collectionSearch.value)) {
        restorePage();
        return;
      }

      if (pagination) pagination.hidden = true;
      if (empty) empty.hidden = true;

      grid.hidden = true;
      grid.setAttribute('aria-busy', 'true');
      status.textContent = 'Buscando en toda la colección…';
      status.hidden = false;

      try {
        const cards = await loadAllCards();
        const query = normalizeText(collectionSearch.value);

        if (!query) {
          restorePage();
          return;
        }

        const matches = cards.filter((card) =>
          normalizeText(card.dataset.productName).includes(query)
        );

        matches.forEach((card) => {
          card.hidden = false;
        });

        grid.replaceChildren(...matches);
        grid.hidden = false;

        if (count) count.textContent = String(matches.length);
        if (empty) empty.hidden = matches.length !== 0;

        status.hidden = true;
        status.textContent = '';
      } catch (error) {
        if (!normalizeText(collectionSearch.value)) {
          restorePage();
          return;
        }

        if (count) count.textContent = '—';

        status.textContent = 'No pudimos completar la búsqueda. Borra el texto y vuelve a intentarlo.';
        status.hidden = false;
      } finally {
        grid.removeAttribute('aria-busy');
      }
    };

    collectionSearch.addEventListener('input', () => {
      window.clearTimeout(debounce);

      if (!normalizeText(collectionSearch.value)) {
        restorePage();
        return;
      }

      debounce = window.setTimeout(searchCollection, 200);
    });
  }
}

document.querySelector('[data-sort-select]')?.addEventListener('change', (event) => event.target.form.submit());

document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
  thumb.addEventListener('click', () => {
    const id = thumb.dataset.galleryThumb;
    document.querySelectorAll('[data-media-id]').forEach((media) => {
      const active = media.dataset.mediaId === id;
      media.hidden = !active;
      media.classList.toggle('is-active', active);
    });
    document.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
  });
});

document.querySelector('[data-variant-select]')?.addEventListener('change', (event) => {
  const option = event.target.options[event.target.selectedIndex];
  const price = document.querySelector('[data-product-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});

document.querySelectorAll('[data-reveal]').forEach((element) => {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    element.classList.add('is-visible');
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  observer.observe(element);
});